export default {
  maxHeight: 800,
  searchShow: true,
  searchMenuSpan: 6,
  calcHeight: 100,
  tip: false,
  border: true,
  index: true,
  indexWidth: 60,
  viewBtn: false,
  selection: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  menu: true,
  menuWidth: 120,
  columnBtn: true,
  refreshBtn:true,
  stripe:true,
  column: [
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      searchslot: true,
      hide: true,
      props: {
        label: 'title',
        value: 'key',
      },
      searchSpan: 6,
    },
    {
      label: '车场名称',
      prop: 'spaceName',
      width: 150,
    },
    {
      label: '区域名称',
      prop: 'regionName',
      span: 12,
    },
    {
      label: '车牌号',
      prop: 'carNo',
      searchSpan: 6,
    },
    {
      label: '车辆分类',
      prop: 'carType',
      width: 100,
    },
    {
      label: '出场时间',
      prop: 'dateRange',
      searchSpan: 12,
      hide: true,
      searchslot: true,
      searchRange: true,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    {
      label: '出场时间',
      prop: 'outTime',
      type: 'datetime',
      searchRange: true,
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
      width: 150,
    },
    // {
    //   label: '出场图片',
    //   prop: 'cloudCarImage',
    //   slot:true,
    //   width:80
    // },
    {
      label: '出场通道名称',
      prop: 'outPassageName',
    },

    {
      label: '支付方式',
      prop: 'payType',
      type: 'select',
      searchslot: true,
      dataType: 'string',
/*      dicUrl: '/api/blade-system/dict/dictionary?code=tempcar_pay_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },*/
      dicData: [
        {'label': '微信', 'value': 'WX'},
        {'label': '支付宝', 'value': 'ZFB'},
        {'label': '现金', 'value': 'XJ'},
        {'label': '其它', 'value': 'OTHER'}
      ]
    },
    {
      label: '应缴总额',
      prop: 'shouldAccount',
      hide: true,
      searchslot: true,
    },
    {
      label: '实缴总额',
      prop: 'realityAccount',
      hide: true,
      searchslot: true,
    },
    {
      label: '入场时间',
      prop: 'inTime',
      searchSpan: 6,
      width: 150,
      type: 'datetime',
      format: 'yyyy-MM-dd HH:mm:ss',
      valueFormat: 'yyyy-MM-dd HH:mm:ss',
    },
    // {
    //   label: '入场图片',
    //   prop: 'cloudCarInImage',
    //   slot:true,
    //   width:80
    // },
    {
      label: '入场通道名称',
      prop: 'inPassageName',
    },
    {
      label: '操作类型',
      prop: 'parkEventType',
      disabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=parkEventType',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      dataType: 'string',
    },
    {
      label: '出场备注',
      prop: 'outMemo',
      width: 200,
      overHidden: true,
    },
  ],
};
